<div class="main-nav">
  <nav class="navbar navbar-dark bg-dark flex-column invisible-scroll px-1" #navbar>
    <div class="container-fluid px-1">
      <div class="navbar-header">
        <button type="button" 
                class="navbar-toggle navbar-toggler d-lg-none" 
                data-bs-toggle="collapse" 
                data-bs-target="#navbarNav" 
                aria-controls="navbarNav" 
                aria-expanded="false"
                aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
            <span class="visually-hidden">Toggle navigation</span>
        </button>

        <a class="navbar-brand d-flex align-items-center flex-column" [routerLink]="['home']">
          <img class="logo lt-nav-logo flex-shrink-0" src="../../../assets/images/ncino_logo_mono_cloud_RGB.png" [routerLink]="['home']" alt="Los Talker Logo" />
          LOS Talker Configuration
        </a>
      </div>

      <div class="navbar-content navbar-nav-scroll invisible-scroll" style="scrollbar-width: none;">
        <div class="clearfix"></div>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="nav navbar-nav flex-column w-100">
                @if (appComponent.userName !== undefined) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['app-user-data']" class="nav-link">
                            <i class="bi bi-person-fill"></i> {{ appComponent.userFullName }}
                        </a>
                    </li>
                }

                @if (checkAccess(['LOSTalker.Client'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['clients']" class="nav-link">
                            <i class="bi bi-list-ul"></i> Clients
                        </a>
                    </li>
                }

                
                @if (checkAccess(['LOSTalker.DevOps'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['servers']" class="nav-link">
                            <i class="bi bi-list-ul"></i> Servers
                        </a>
                    </li>
                }

                @if (checkAccess(['LOSTalker.BaseMapping'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['endpoint/baseMapping']" class="nav-link">
                            <i class="bi bi-box"></i> Base Mappings
                        </a>
                    </li>
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['endpoint/generic-endpoint']" class="nav-link">
                            <i class="bi bi-box"></i> Generic Endpoints
                        </a>
                    </li>
                }

                @if (checkAccess(['LOSTalker.Admin'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['admin-dashboard']" class="nav-link">
                            <i class="bi bi-list-ul"></i> Admin Menu
                        </a>
                    </li>
                }
                                
                @if (checkAccess(['LOSTalker.Integration.CompenSafe.FastFetch', 'LOSTalker.Integration.LimeGear.FastFetch'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['process-data', 'fastfetch']" class="nav-link">
                            <i class="bi bi-arrow-up-circle"></i> FastFetch
                        </a>
                    </li>
                }

                @if (checkAccess(['LOSTalker.Integration.CompenSafe.DataSwap', 'LOSTalker.Integration.LimeGear.DataSwap'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['process-data', 'dataswap']" class="nav-link">
                            <i class="bi bi-arrow-repeat"></i> DataSwap
                        </a>
                    </li>
                }

                @if (checkAccess(['LOSTalker.Integration.CompenSafe', 'LOSTalker.Integration.LimeGear'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['client-pushbacks']" class="nav-link">
                            <i class="bi bi-skip-backward"></i> PushBacks
                        </a>
                    </li>
                }

                @if (checkAccess(['LOSTalker.Client', 'LOSTalker.Client.InvoicingReports'])) {
                    <li class="nav-item dropdown" >
                        <a class="nav-link dropdown-toggle" 
                            id="navbarDropdown"
                            style="overflow:visible"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="true"
                            [attr.aria-expanded]="isDropdownOpen()"
                            role="button" 
                            (click)="toggleDropdown()"
                            aria-haspopup="true"
                            [class.show]="isDropdownOpen()">
                            <i class="bi bi-pencil-square"></i> <span class="pe-3">Invoicing ...</span>
                        </a>

                        <ul 
                            class="dropdown-menu dropdown-menu-dark"
                            [class.show]="isDropdownOpen()"
                            aria-labelledby="navbarDropdown">
                            <li [routerLinkActive]="['link-active']" class="dropdown-item">
                                <a [routerLink]="['invoicing-report/invoiced-loans-report']" class="nav-link">
                                    <i class="bi bi-list-ul"></i> Loans Report
                                </a>
                            </li>
                            <li [routerLinkActive]="['link-active']" class="dropdown-item">
                                <a [routerLink]="['invoicing-report/contract-metrics-export']" class="nav-link">
                                    <i class="bi bi-table"></i> Contract Metrics Export
                                </a>
                            </li>
                        </ul>
                    </li>
                }
                


                @if (checkAccess(['LOSTalker.DevOps'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['swagger-interface-v2']" class="nav-link">
                        <i class="bi bi-pencil-square"></i> Swagger Interface V2
                        </a>
                    </li>
                }

                @if (checkAccess(['LOSTalker.DevOps', 'LOSTalker.Integration'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['errorMessagesv3']" class="nav-link">
                        <i class="bi bi-exclamation-lg"></i> Current Errors V3
                        </a>
                    </li>
                }

                @if (checkAccess(['LOSTalker.DevOps', 'LOSTalker.Reporting'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['reports']" class="nav-link">
                        <i class="bi bi-list-ul"></i> Reports
                        </a>
                    </li>
                }

                @if (checkAccess(['LOSTalker.Client', 'LOSTalker.Client.LOSData'])) {
                    <li [routerLinkActive]="['link-active']" class="nav-item">
                        <a [routerLink]="['field-paths']" class="nav-link">
                        <i class="bi bi-list-ul"></i> Field Paths
                        </a>
                    </li>
                }

                @if (checkAccess(['LOSTalker.DevOps'])) {
                    <li class="nav-item dropdown" >
                        <a class="nav-link dropdown-toggle" 
                           id="navbarDropdown" 
                           role="button" 
                           data-bs-toggle="dropdown" 
                           (click)="toggleAddMenuDropdown()"
                            [attr.aria-expanded]="isAddMenuDropdownOpen()"
                            aria-haspopup="true"
                            [class.show]="isAddMenuDropdownOpen()">
                            <i class="bi bi-pencil-square"></i>
                            <span class="pe-3">Add ...</span>
                        </a>

                        <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="navbarDropdown">
                            @if (checkAccess(['LOSTalker.Admin'])){
                                <li [routerLinkActive]="['link-active']" class="dropdown-item" >
                                    <a [routerLink]="['add/client']" class="nav-link">
                                        <i class="bi bi-pencil-square"></i> Client
                                    </a>
                                </li>
                                <li [routerLinkActive]="['link-active']" class="dropdown-item" >
                                    <a [routerLink]="['add/integration']" class="nav-link">
                                        <i class="bi bi-pencil-square"></i> Integration
                                    </a>
                                </li>
                            }
                            
                            <li [routerLinkActive]="['link-active']" class="dropdown-item" >
                                <a [routerLink]="['addIntegrationIdentifier']" class="nav-link">
                                    <i class="bi bi-pencil-square"></i> Identifier
                                </a>
                            </li>
                            <li [routerLinkActive]="['link-active']" class="dropdown-item" >
                                <a [routerLink]="['add/baseMapping']" class="nav-link">
                                    <i class="bi bi-pencil-square"></i> Base Mapping
                                </a>
                            </li>
                        </ul>
                    </li>
                }
            </ul>
        </div>
      </div>
      
    </div>
  </nav>
</div>
